exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spin-icon[data-v-23dbdc5b] {\n  -webkit-animation: loader-data-v-23dbdc5b 1s infinite;\n          animation: loader-data-v-23dbdc5b 1s infinite;\n  display: flex;\n}\n@-webkit-keyframes loader-data-v-23dbdc5b {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(-360deg);\n}\n}\n@keyframes loader-data-v-23dbdc5b {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(-360deg);\n}\n}\n", ""]);

// exports
